class SliderMenu extends HTMLElement {
  constructor() {
    super();
    this.superMenus = this.querySelectorAll(".super-menu-link");
    this.expandableMenus = this.querySelectorAll(".menu-level-2");
    this.levelThreeItems = this.querySelectorAll(".menu-level-3-item");
    this.levelFours = this.querySelectorAll(".menu-level-4");

    this.assignMenuWidth();
    window.addEventListener("resize", this.assignMenuWidth.bind(this));

    this.superMenus.forEach((menu) => {
      if (menu.querySelector(".menu-level-2")) {
        menu.addEventListener("mouseover", () => {
          menu.querySelector(".menu-item").classList.add("active");
          menu.querySelector(".menu-level-2").classList.add("open");
        });
        menu.addEventListener("mouseout", () => {
          menu.querySelector(".menu-item").classList.remove("active");
          menu.querySelector(".menu-level-2").classList.remove("open");
        });
      }
    });
    this.expandableMenus.forEach((menu) => {
      this.calculateMenuPosition(menu);
    });
    this.levelThreeItems.forEach((item) => {
      if (item.querySelector(".menu-level-4")) {
        item.addEventListener("mouseover", () => {
          item.querySelector(".menu-level-3-link").classList.add("active");
          item.querySelector(".menu-level-4").classList.add("open");
        });
        item.addEventListener("mouseout", () => {
          item.querySelector(".menu-level-3-link").classList.remove("active");
          item.querySelector(".menu-level-4").classList.remove("open");
        });
      }
    });
    this.levelFours.forEach((menu) => {
      this.calculateLevelFourPosition(menu);
      menu.addEventListener("mouseover", () => {
        this.calculateLevelFourPosition(menu);
      });
    });
  }

  calculateLevelFourPosition(menu){
    if (document.dir == "ltr"){
      const menuRightPosition = menu.getBoundingClientRect().right;
      const windowWidth = window.innerWidth;
      if(menuRightPosition > windowWidth){
        menu.style.left = "auto";
        menu.style.right = 0;
      }
    } else if (document.dir == "rtl"){
      const menuLeftPosition = menu.getBoundingClientRect().left;
      if(menuLeftPosition < 0){
        menu.style.right = "auto";
        menu.style.left = 0;
      }
    }
  }
  calculateMenuWidth() {
    const sectionContainer = document.querySelector(".section-container");
    const sectionContainerOffset = sectionContainer.offsetWidth;
    const sectionContainerStyles = getComputedStyle(sectionContainer);
    const sectionContainerPaddings =
      parseInt(sectionContainerStyles.paddingLeft) +
      parseInt(sectionContainerStyles.paddingRight);
    const megaMenuWidth = this.querySelector(
      ".mega-menu-container"
    ).offsetWidth;
    const width =
      sectionContainerOffset - sectionContainerPaddings - megaMenuWidth;
    return width;
  }
  calculateMenuPosition(menu) {
    const menuHeight = menu.offsetHeight;
    const liItem = menu.parentElement;
    const liItemBottomPos = liItem.offsetTop + liItem.offsetHeight;
    const possibleTop = liItemBottomPos - menuHeight;

    if (menuHeight > this.offsetHeight || menuHeight > liItemBottomPos) {
      menu.style.top = 0;
      return;
    } else {
      menu.style.top = liItemBottomPos - menuHeight + "px";
      return;
    }
  }
  assignMenuWidth() {
    this.expandableMenus.forEach((menu) => {
      menu.style.maxWidth = this.calculateMenuWidth() + "px";
    });
  }
}
customElements.define("slider-menu", SliderMenu);
